var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "counterparty" },
    [
      _c(
        "div",
        { staticClass: "panel sluzebka" },
        [
          _c("make_doc_title", {
            attrs: {
              title: "Чорний список контрагентів для службових по оплаті",
              button_action: "add_counterparty",
              button_plus: this.editable,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "panel-toolbar" }),
          _vm._v(" "),
          _c("div", { staticClass: "panel-container show" }, [
            _c(
              "div",
              { staticClass: "panel-content" },
              [
                _c(
                  "b-form-group",
                  {
                    staticClass: "mb-0",
                    attrs: {
                      label: "Фільтр",
                      "label-for": "filter-input",
                      "label-cols-sm": "3",
                      "label-align-sm": "right",
                      "label-size": "sm",
                    },
                  },
                  [
                    _c(
                      "b-input-group",
                      { attrs: { size: "sm" } },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: "filter-input",
                            type: "search",
                            placeholder: "пошук ЄДРПОУ",
                          },
                          model: {
                            value: _vm.filter,
                            callback: function ($$v) {
                              _vm.filter = $$v
                            },
                            expression: "filter",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "b-input-group-append",
                          [
                            _c(
                              "b-button",
                              {
                                attrs: { disabled: !_vm.filter },
                                on: {
                                  click: function ($event) {
                                    _vm.filter = ""
                                  },
                                },
                              },
                              [_vm._v("Очистити")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("b-table", {
                  staticClass: "table-responsive-lg w-10 mt-4",
                  attrs: {
                    "head-variant": "dark",
                    striped: "",
                    items: _vm.list_items,
                    fields: _vm.fields,
                    filter: _vm.filter,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "cell(delete)",
                      fn: function (row) {
                        return [
                          _vm.editable
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "mr-2",
                                  attrs: { size: "sm", variant: "danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.del(row.item)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            Видалити\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "cell(info)",
                      fn: function (row) {
                        return [
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-2",
                              attrs: { size: "sm", variant: "info" },
                              on: {
                                click: function ($event) {
                                  return _vm.info(row.item)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Інформація\n                        "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("company_info"),
      _vm._v(" "),
      _c("counterparty_add"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }